module.exports = __webpack_public_path__ + "img/2142.65622fff.gif";